import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const base = () => css`
  .menu-list {
    padding-left: ${rem(12)};
  }
`

const pinnedItem = theme => css`
  svg {
    color: ${theme.color.mainNav.pin};
    width: ${rem(12)};
    height: ${rem(12)};
  }
`

const leftNavFooter = theme => css`
  hr {
    border: 0;
    border-top: 1px solid ${theme.color.monochromeAlt.black};
    border-bottom: 1px solid ${theme.color.monochrome.dark};
    margin: 0;
  }

  .left-nav-footer-container {
    color: ${theme.color.mainNav.color};
    margin: 22px 14px 28px 14px;
    text-align: center;

    .title {
      margin-bottom: 8px;
      font-size: ${theme.fontSize.large};
      font-weight: ${theme.fontWeight.medium};
    }
  }
`

export const styles = {
  base,
  pinnedItem,
  leftNavFooter,
}
